import { TinyColor } from '@ctrl/tinycolor';
export const colors = {
  primary: {
    90: '#2F39EE',
    70: '#535AF1',
    700: '#535AF1',
    50: '#7B81F4',
    500: '#7B81F4',
    20: 'rgba(83, 90, 241, 0.15)',
    200: 'rgba(83, 90, 241, 0.15)',
    900: '#2F39EE',
  },

  secondary: {
    200: 'rgba(20, 160, 255, 0.15)',
    700: '#1080CC',
    900: '#14A0FF',
  },

  neutral: {
    90: '#051633',
    70: '#465570',
    60: '#2C446E',
    10: '#E6E8EB',
    50: '#4A6594',
  },

  lightblue: '#EDEFFE',

  blue: {
    700: '#1080CC',
    background: '#DCF1FF',
    shopping_list_background: '#EDEFFE',
    input_background: '#F5F7F9',
    input_background_hovered: new TinyColor('#F5F7F9').darken(20).toHexString(),
  },

  grey: {
    dim: '#B6C2D8',
    dark: '#524E65',
    300: '#E7E7E7',
    200: '#F5F7F9',
  },

  outline: {
    blue: '#DAE0EB',
  },

  orange: {
    crayola: '#FF7B43',
    background: '#FFEBE3',
  },

  green: {
    emerald: '#06CD81',

    700: '#059669',

    todo_list_background: '#E4F8EF',
    background: '#E4F8EF',
  },

  pink: {
    primary: '#E559A8',
    background: '#FBEEF7',
  },

  yellow: {
    700: '#CF9B07',
    background: '#FFF6DA',
  },

  success: {
    60: 'rgba(5, 150, 105, 1)',
  },

  error: {
    60: '#E65E59',
  },

  text: {
    input: 'rgba(5, 22, 51, 0.7)',
    green: '#2B8279',
    green_background: '#E2F1EE',

    yellow: '#BE8C00',
    yellow_background: '#FFF5DA',
  },
};
